import Route from '@ember/routing/route';

export default class GuidesRoute extends Route {}
